export enum FlightType {
  ONE_WAY = "oneway",
  ROUND_TRIP = "roundtrip",
  MULTI_CITY = "multicity",
}

export const isValidFlightType = (flight?: string) => {
  if (flight) {
    for (const key in FlightType) {
      if (FlightType.hasOwnProperty(key)) {
        const actualFlight = FlightType[key];
        if (flight === actualFlight) {
          return actualFlight;
        }
      }
    }
  }

  return undefined;
};

export const FlightTypeCodeMap = {
  roundtrip: "ROUND_TRIP",
  oneway: "ONE_WAY",
  multicity: "MULTIPLE_DESTINATION",
  default: "ROUND_TRIP",
};
